import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

/** Ported from gpp-website blocking popup logo for matching dimensions. */
export const BetWrightCompliancePopupLogo = ({ className }: PropsType): React.ReactElement => (
    <SvgElement
        className={className}
        xmlns='http://www.w3.org/2000/svg'
        width='177'
        height='24'
        viewBox='0 0 177 24'
        fill='none'
    >
        <path
            fill='#F9F9F9'
            d='m73.737.383 4.394 16.74L82.177.383h5.579L81.13 23.549h-5.266l-4.08-15.907-4.046 15.907h-5.265L55.813.383h5.544l4.08 16.74 4.43-16.74M99.856 14.725c2.51-.59 5.091-2.778 5.091-6.876 0-4.307-2.963-7.468-7.812-7.468H89.15l-2.894 10.122v13.044h4.952v-8.3h3.627l4.568 8.3h5.684l-5.231-8.822Zm-3.453-3.715h-5.197V4.62h5.197c1.988 0 3.487 1.25 3.487 3.194 0 1.945-1.499 3.196-3.487 3.196ZM105.928.383v19.093l2.415 4.072h2.537V.383h-4.952ZM123.292 15.003h6.19v2.813c-1.012.903-2.895 1.77-5.023 1.77-4.22 0-7.288-3.229-7.288-7.605 0-4.375 3.068-7.605 7.288-7.605a6.608 6.608 0 0 1 5.51 2.917l4.115-2.222C132.306 2.327 129.272 0 124.459 0c-6.801 0-12.38 4.654-12.38 11.983 0 7.329 5.579 12.017 12.38 12.017 4.22 0 7.533-1.737 9.904-4.376v-8.856l-9.998-.075M151.643 13.823h-10.984v9.724h-4.952V.383h4.952v9.1h10.984v-9.1h4.987v23.166h-4.987V13.823ZM176.5.405V.383h-.022l.022.022ZM176.447.383h-18.501v4.341h6.801v18.823h4.986V4.724h6.767l-2.132-2.27 2.079-2.071Z'
        />
        <path
            fill='#FFCE00'
            d='M55.82 4.724h-4.774v18.823H46.06V4.57h-6.8v-.032l-2.113-2.066L39.26.406V.38h15.311l1.248 4.343Z'
        />
        <path
            fill='#FFCE00'
            d='M37.533 4.647v-.433l-1.782-1.741L37.533.73V.41h-16.46v23.164h16.46v-4.271H26.025V13.92H37.29V9.683H26.025V4.647h11.508ZM15.425 11.605c2.197-.452 4.011-2.397 4.011-5.315 0-3.09-2.267-5.904-6.696-5.904H.5v.048l2.088 2.04L.5 4.516v19.036h12.624c4.429 0 6.765-2.778 6.765-6.251 0-2.918-1.988-5.315-4.464-5.696v-.001ZM5.452 4.59h6.208c1.673 0 2.72 1.111 2.72 2.536 0 1.424-1.046 2.57-2.72 2.57H5.452V4.59Zm6.382 14.76H5.452v-5.453h6.382c1.952 0 3 1.251 3 2.71 0 1.668-1.117 2.744-3 2.744Z'
        />
    </SvgElement>
);
